require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./comparison-of-machine-learning-methods-in-email-spam-detection.json") })
        }
      }, "path---comparison-of-machine-learning-methods-in-email-spam-detection");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---comparison-of-machine-learning-methods-in-email-spam-detection!./.cache/json/comparison-of-machine-learning-methods-in-email-spam-detection.json
// module id = 328
// module chunks = 231608221292675